import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Table, TableModule } from 'primeng/table';
import {default as GridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/Venue-Details-Columns.json';
import { CommonModule, NgClass, LowerCasePipe} from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { QuickSearchComponent } from 'app/Shared/Component/quick-search/quick-search.component';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { VenueDetailsService } from './venue-details.service';
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { GridService } from 'app/Shared/Services/grid.service';
import { UserService } from 'app/Shared/Services/user.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { map } from 'rxjs';
import { asBlob, generateCsv } from 'export-to-csv';
import saveAs from 'file-saver';
import { HttpErrorResponse } from '@angular/common/http';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { VenueDetails } from './venue-details.model';
import { AddEditViewVenueDetailsComponent } from './add-edit-view-venue-details/add-edit-view-venue-details.component';

@Component({
  selector: 'app-venue-details',
  imports: [CommonModule, TableModule, ButtonModule, FormsModule,
        FilterPanelComponent, MatProgressSpinnerModule, NgClass, LowerCasePipe,
        MatTooltipModule, ConfirmDialogModule,ToastModule, QuickSearchComponent,AddEditViewVenueDetailsComponent],
  templateUrl: './venue-details.component.html',
  styleUrl: './venue-details.component.scss'
})
export class VenueDetailsComponent implements OnInit, OnDestroy {

  @ViewChild(('dt')) dt!: Table |any;
  GridColumns = GridColumnsJSON;
  columns: any = [];
  public tbldatamsg = 'L o a d i n g . . . . .'; 
  emptytbldatamsg = "Data not found";
  subscription: any;
  selectedRow: any = [];
  sortData: any = { field: '', order: 0 };
  sortClickCounter: number = 0;
  isExportToCSV = false;
  rowData: any = [];
  showDialog = false;
  dialogMode: any = 'add'
  selectedRowData: VenueDetails = new VenueDetails();
  

  quickFilterArray:any;

  constructor(public venueDetailsService: VenueDetailsService,
        public userService: UserService,
        private readonly gridService: GridService,
        private readonly emitterService: EmitterService,
        public constantService: ConstantService,
        private readonly messageService: MessageService,
        private readonly sortPipe: SortPipe,
        private readonly urlsService: UrlsService,
        private sharedHttpClientService: SharedHttpClientService,
        private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    this.venueDetailsService.rowcount = this.constantService.DEFAULT_ROWSIZE;
    this.venueDetailsService.endLimit = this.venueDetailsService.rowcount
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.getData();
      }
    });
    this.getColumns();
    this.venueDetailsService.defaultFilter();
    this.getData();

    this.quickFilterArray = [
      {
        label: 'Venue MPID', columnname: 'venueMPID', placeholder: 'Venue MPID',
        width: '', datatype: 'String'
      },
      {
        label: 'Venue Name', columnname: 'venueName', placeholder: 'Venue Name',
        width: '', datatype: 'String', isLarge: true
      },      
    ];
  }

  getData() {
    this.venueDetailsService.reloadData();
  }

  getColumns() {
    let column: any;
    column = this.GridColumns;
    this.columns = this.GridColumns.filter((col: any) => col.ui_columnname !== "Action");
    if (column !== null || column !== undefined) {
      this.GridColumns = this.gridService.getGridColumns(column);
    }
  }


    exportToCSV() {
    if(this.userService.enableFileExport()){
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' });

    this.messageService.add({ severity: 'info', summary: 'File', detail: 'Please wait.. Preparing export file to download..' });
    this.isExportToCSV = true;
    const filename = 'ODR_Venue_Details_' + this.userService.getyyyyMMddDateFormate(new Date());
    let payload = {
      "mpid": this.userService.getActiveMPID(),
      "data": this.venueDetailsService.defaultFilterArray,
      "startLimit": 0,
      "endLimit": this.venueDetailsService.totalRecords
    }
    this.venueDetailsService.getData(payload)
      .pipe(map((response: Response) => {
        return response;
      }))      
      .subscribe({
        next: (dataset: any) => {
          this.isExportToCSV = false;
            let data = dataset.Data;
            if (data.length > 0) {
              const options:any = {
                fieldSeparator: ',',
                quoteStrings: '"',
                decimalSeparator: '.',
                showLabels: true,
                showTitle: true,
                title: filename,
                useTextFile: false,
                useBom: true,
                useKeysAsHeaders: true,
                filename: filename
              };
              const csv = generateCsv(options)(this.constantService.getExportData(data, GridColumnsJSON));
              const blob = asBlob(options)(csv);
              saveAs(blob, filename);
              this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
              this.userService.logUserActivity('Export CSV ' + filename, null, {
                'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
                'Text2': 'User Filter Parameters: ' + JSON.stringify(this.venueDetailsService.defaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
              });
            } else {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
              this.userService.logUserActivity('Export CSV ' + filename, null, {
                'Text1': 'No data found',
                'Text2': 'User Filter Parameters: ' + JSON.stringify(this.venueDetailsService.defaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
              });
            }
        },
        error: (err: HttpErrorResponse) => {
          this.isExportToCSV = false;
        }
      });  
    }
  }

  onView(ri:any, selectedRow:any) {
    this.selectedRowData = selectedRow;
    this.dialogMode = 'view'
    this.showDialog = true;
    /* Catch User Action Log */
    this.userService.logUserActivity("View - ODR Venue Details", null, {
      'Text1': this.userService.userFirstName + ' Viewd ODR Venue Details',
      'Text2': 'User Filter Parameters: ' + JSON.stringify(selectedRow)
    });
  }

  onAdd() {
    this.selectedRowData = new VenueDetails();
    this.selectedRowData.createdDate = this.userService.getDateTimeFormate(new Date());
    this.selectedRowData.updatedDate = this.userService.getDateTimeFormate(new Date());
    this.selectedRowData.createdUser = this.userService.getUserName();
    this.selectedRowData.updatedUser = this.userService.getUserName();

    this.dialogMode = 'add'
    this.showDialog = true;

  }

  onEdit(ri:any, selectedRow:any) {
    this.selectedRowData = selectedRow
    this.dialogMode = 'edit'
    this.showDialog = true;
  }

  onDelete(ri:any, selectedRow:any) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this record?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"destination-details-confirm-dialog-button",
      rejectButtonStyleClass:"destination-details-confirm-dialog-button",
      accept: () => {
        this.venueDetailsService.isLoadingResults = true;
        let payload = {
          "firmMPID": this.userService.getActiveMPID(),
          "id": selectedRow['id']
        }
        
        /* Catch User Action Log */
        this.userService.logUserActivity("Delete - ODR Venue Details", null, {
          'Text1': this.userService.userFirstName + ' Deleted ODR Venue Details',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(payload)
        });

        this.venueDetailsService.getDelete(payload)
          .pipe(map((response: Response) => {
            return response;
          }))
          .subscribe({
            next: (data: any) => {
              this.venueDetailsService.isLoadingResults = false;
              if (data.status) {
                this.getData();
                this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'Record deleted' });
                this.messageService.add({ severity: 'success', summary: 'Delete Record Message', detail: data.data });
              } else {
                this.messageService.add({ severity: 'error', summary: 'Delete Record Message', detail: data.data });
              }
            },    
            error: (err: HttpErrorResponse) => {
              this.venueDetailsService.isLoadingResults = false;
              this.messageService.add({ severity: 'error', summary: 'Delete Record Message', detail: err.message });
            }
          });  
      },
      reject: () => {
        this.messageService.add({ severity: 'warn', summary: 'Cancelled', detail: 'Action cancelled' });
      }
    });
  }

  onApprove() {
    const payload = {
      "isApproved": true,
      "rowIDs": this.selectedRow.filter((row: any) => row.id).map((obj: any) => obj.id),
      "firmMPID": this.userService.getActiveMPID(),
      "user": this.userService.getUserName(),
    }
    
    /* Catch User Action Log */
    this.userService.logUserActivity("Approve - ODR Venue Details", null, {
      'Text1': this.userService.userFirstName + ' Approved ODR Venue Details',
      'Text2': 'User Filter Parameters: ' + JSON.stringify(payload)
    });

    if(this.selectedRow.length  > 0) {

      if(this.hasApprovedRecordsSelected) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Selection contains already approved record(s). Please deselect them to proceed.'
        });
        return;
      }

      if(this.areSelectedVenueDetailsValid()) {
        this.venueDetailsService.isLoadingResults = true;
        this.venueDetailsService.getApprove(payload)
          .pipe(map((response: Response) => {
            return response;
          }))
          .subscribe({
            next: (data: any) => {
              this.venueDetailsService.isLoadingResults = false;
              if (data.status) {
                this.selectedRow = [];
                this.venueDetailsService.reloadData();
                this.messageService.add({
                  severity: 'success',
                  summary: 'Success',
                  detail: 'Records updated successfully'
                });
              } else {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: data.message
                });
              }
            },
            error: (err: HttpErrorResponse) => {
              this.venueDetailsService.isLoadingResults = false;
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: err.message
              });
            }
          });
      } else {
            this.messageService.add({ 
            severity: 'warn', 
            summary: 'Error', 
            detail: 'Please fill all required fields correctly.' 
        });
       }
    } else {
            this.messageService.add({ 
        severity: 'warn', 
        summary: 'Error', 
        detail: 'Please select one or more rows to approve the venue details.' 
      });
    }

  }

  get hasApprovedRecordsSelected(): boolean {
    return this.selectedRow.some((row: any) => row.isApproved === true || row.isApproved === 1);
  }

  areSelectedVenueDetailsValid() {

    if(this.selectedRow.length > 0) {

      const fieldsToValidate = [
        {name: 'materialAspect', type: 'string'},
        {name: 'micCode', type: 'string'},
        {name: 'venueMPID', type: 'string'},
        {name: 'venueName', type: 'string'},
        {name: 'venueType', type: 'string'},
        {name: 'reportingQuarter', type: 'number'},
        {name: 'reportingYear', type: 'number'}
      ];

      for (const row of this.selectedRow) {
        for (const field of fieldsToValidate) {
          const value = row[field.name];

          if (field.type === 'string' && (!value || value.trim() === '')) {
            return false;
          }

          if (field.type === 'number' && (!value || value === 0)) {
            return false;
          }
        }
      }

    }

    return true;
  }

  changePage(event:any) {
    this.venueDetailsService.startLimit = event.first;
    this.venueDetailsService.rowcount = event.rows;
    this.venueDetailsService.endLimit = this.venueDetailsService.startLimit + this.venueDetailsService.rowcount;
    if (this.venueDetailsService.endLimit > this.venueDetailsService.totalRecords) {
      this.venueDetailsService.endLimit = this.venueDetailsService.totalRecords;
    }
    this.getData();
  }


    FilterApplyFilterEvent(event:any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.venueDetailsService.defaultFilterArray = [];
    this.venueDetailsService.defaultFilterArray = event;
    this.venueDetailsService.startLimit = 0;
    this.venueDetailsService.endLimit = this.venueDetailsService.rowcount
    this.getData();
  }

  sort(event:any) {
    if (event.multisortmeta[0].field != "") {
      if (this.sortClickCounter !== 3 && (this.sortData.field === "" || this.sortData.field === event.multisortmeta[0].field)) {
        this.sortClickCounter = this.sortClickCounter + 1;
      } else {
        this.sortClickCounter = 1;
      }
      if (this.sortClickCounter !== 3) {
        let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
        this.sortData.field = event.multisortmeta[0].field;
        this.sortData.order = sortOrder;
        this.venueDetailsService.dataset = this.sortPipe.transform(this.venueDetailsService.dataset, this.sortData.order, this.sortData.field);
      } else {
        this.resetSort();
      }
    }
  }
  resetSort() {
    this.dt.multiSortMeta[0].field = 'abc';
    this.dt.multiSortMeta[0].order = 0;
    this.venueDetailsService.dataset = this.venueDetailsService.defaultData;
  }

  updateDefaultArray($event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.venueDetailsService.defaultFilterArray = $event;
    this.venueDetailsService.startLimit = 0;
    this.venueDetailsService.endLimit = this.venueDetailsService.rowcount;
    this.getData();
  }

  clearQuickSearch($event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.venueDetailsService.defaultFilterArray = $event;
    this.venueDetailsService.startLimit = 0;
    this.venueDetailsService.endLimit = this.venueDetailsService.rowcount;
    this.getData();
  }


  ngOnDestroy(): void {
      if (this.subscription)
        this.subscription.unsubscribe();
  }

}
